const safeJSONParse = (value) => {
  try {
    if (!value || value === "undefined") return null;
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const initialState = {
  user: safeJSONParse(localStorage.getItem("USER")),
  token: localStorage.getItem("TOKEN") || null,
};

export default function RootReducer(state = initialState, action) {
  switch (action.type) {

    /* ================= LOGIN ================= */
    case "ADD_USER": {
      // SUPPORT BOTH payload formats
      const user =
        action.payload?.user || action.payload || null;

      const token =
        action.payload?.token || action.payload?.TOKEN || null;

      if (user && typeof user === "object") {
        localStorage.setItem("USER", JSON.stringify(user));
      }

      if (token) {
        localStorage.setItem("TOKEN", token);
      }

      return {
        ...state,
        user,
        token,
      };
    }

    /* ================= LOGOUT ================= */
    case "REMOVE_USER":
      localStorage.removeItem("USER");
      localStorage.removeItem("TOKEN");
      sessionStorage.clear();

      return {
        ...state,
        user: null,
        token: null,
      };

    default:
      return state;
  }
}
